export default "__VITE_ASSET__Q88yKZSs__"